<template>
    <div
        class="markdown-editor markdown-view"
        :class="{ 'markdown-view--inline': inline }"
    >
        <Viewer
            ref="viewerRef"
            :initial-value="value"
            :options="markdownViewerOptions"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import '@toast-ui/editor/dist/toastui-editor.css'
import { markdownViewerOptions } from '@/composables/useMarkdownViewerOptions'

const Viewer = () => import('@toast-ui/vue-editor').then(m => m.Viewer)

interface Props {
    value: string
    inline?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    value: '',
    inline: false
})

const viewerRef = ref<{ invoke: (method: string, ...args: unknown[]) => unknown } | null>(null)

watch(
    () => props.value,
    (value) => {
        viewerRef.value?.invoke('setMarkdown', value ?? '')
    }
)
</script>

<style lang="scss">
@import '@/assets/scss/components/_markdown-editor.scss';

.markdown-view--inline {
    display: inline;
    width: 100%;
    vertical-align: baseline;

    > div {
        display: inline;
    }

    .toastui-editor-contents {
        display: inline;
        font-size: inherit;
        font-family: inherit;
        line-height: inherit;
    }

    .toastui-editor-contents p {
        margin: 0;
        display: inline;
        color: inherit;
    }

    .toastui-editor-contents a {
        color: var(--primary-actions);
    }
}
</style>
